var map = {
	"./icons/cloud/1-infraestruturas.svg": 294,
	"./icons/cloud/2-aplicacoes.svg": 295,
	"./icons/cloud/3-publica.svg": 296,
	"./icons/cloud/4-privada.svg": 297,
	"./icons/cloud/5-suporte.svg": 298,
	"./icons/homepage/1-icon.svg": 299,
	"./icons/homepage/2-icon.svg": 300,
	"./icons/homepage/3-icon.svg": 301,
	"./icons/homepage/4-icon.svg": 302,
	"./icons/homepage/5-icon.svg": 303,
	"./icons/homepage/6-icon.svg": 304,
	"./icons/icon-rato.svg": 164,
	"./icons/jobs/1_curiosidade.svg": 305,
	"./icons/jobs/2_atitude.svg": 306,
	"./icons/jobs/3_transparencia.svg": 307,
	"./icons/jobs/4_equipa.svg": 308,
	"./icons/play.svg": 115,
	"./icons/ux-ui/1-comunicacao.svg": 309,
	"./icons/ux-ui/2-produtos.svg": 310,
	"./icons/ux-ui/3-aumento.svg": 311,
	"./icons/why-nearshorit/1-talento.svg": 312,
	"./icons/why-nearshorit/2-reducao-custos.svg": 313,
	"./icons/why-nearshorit/3-reducao-risco.svg": 314,
	"./icons/why-nearshorit/4_projetos.svg": 315,
	"./icons/why-nearshorit/5_core.svg": 316,
	"./icons/why-nearshorit/6_eficiencia.svg": 317,
	"./icons/why-nearshorit/7_proximidade.svg": 318,
	"./icons/world.svg": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 698;